import styled from '@emotion/styled';

const StyledLabel = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  width: ${(props) => (props.$fullWidth ? '100%' : 'auto')};
`;

const StyledCheckbox = styled.input``;

const StyledSpan = styled.span`
  width: ${(props) => (props.$fullWidth ? 'auto' : '36px')};
  display: inline-flex;
  align-items: center;
  padding: 0px 0px 0px 2px;
  flex: ${(props) => (props.$fullWidth ? '1 1 auto' : '0 0 auto')};
  min-width: 0;
`;

export default function CheckboxButtonInput({ checked, children, onClick, fullWidth, ...rest }) {
  return (
    <StyledLabel $fullWidth={fullWidth}>
      <StyledCheckbox
        type="checkbox"
        checked={checked}
        role="checkbox"
        aria-checked={checked}
        aria-label={children}
        onChange={onClick}
        {...rest}
      />
      <StyledSpan $fullWidth={fullWidth}>{children}</StyledSpan>
    </StyledLabel>
  );
}
